import { IOfferSpendByAccountListTableLang } from '../../../types/lang'

export const offerSpendByAccountListTableLang: IOfferSpendByAccountListTableLang = {
	offer_spend_by_account_list_table: {
		column_account_id: 'Account ID_ru',
		column_account: 'Account_ru',
		column_account_in_group: 'Account in Group_ru',
		column_kt_group: 'KT Group_ru',
		column_amount: 'Amount_ru',
		column_date: 'Date_ru',
	}
}